/**
 * Textos en espanol.
 *
 * Solo estan las pantallas que un cliente usa a diario: Conversaciones,
 * Oportunidades y Contactos. El resto del CRM sigue con su texto escrito a
 * mano; se ira pasando por aqui cuando toque. Las claves se agrupan por
 * pantalla para que se vea de un tirazo que falta traducir.
 */
export default {
  comun: {
    todas: 'Todas',
    cancelar: 'Cancelar',
    guardar: 'Guardar',
    guardando: 'Guardando…',
    siguiente: 'Siguiente',
    borrar: 'Borrar',
    agregar: 'Agregar',
    enviar: 'Enviar',
    cargando: 'Cargando…',
    buscar: 'Buscar ...',
    limpiar: 'Limpiar',
    telefono: 'Teléfono',
    correo: 'Correo',
    nombre: 'Nombre',
    apellido: 'Apellido',
    etapa: 'Etapa',
    idioma: 'Idioma',
    sinDeshacer: 'Esta acción no se puede deshacer.',
    seguro: '¿Seguro que quieres borrarlo?',
    si: 'Sí',
    acciones: 'Acciones',
    volver: 'Volver',
    deTotal: '{desde}-{hasta} de {total}',
  },

  formularios: {
    titulo: 'Formularios',
    contador: 'formularios',
    agregarNuevo: '+ Nuevo formulario',
    colTitulo: 'Título',
    colSubtitulo: 'Subtítulo',
    colUrl: 'Enlace',
    enlaceCopiado: 'Enlace copiado',
    tituloModal: 'Datos del formulario',
    phTitulo: 'Escribe el título',
    phSubtitulo: 'Escribe el subtítulo',
    landingPropia: 'Landing propia (HTML) — opcional',
    phLanding: 'Pega aquí el HTML de tu landing',
    ayudaLanding: 'Pega el código de tu landing. {sinFormulario}: lo ponemos nosotros para que los datos lleguen a tu embudo. Si quieres decidir dónde aparece, pon {etiqueta} en el sitio que prefieras; si no, se coloca al final.',
    ayudaLandingSinFormulario: 'No incluyas un formulario',
    paginaGracias: 'Página de gracias (URL) — opcional',
    mensajeAlEnviar: 'Mensaje al enviar — opcional',
    phMensajeGracias: '¡Gracias! Te contactaremos pronto.',
    seleccionarArchivo: 'Seleccionar archivo',
    examinar: 'Examinar',
    vistaPrevia: 'Vista previa',
    actualizarFormulario: 'Actualizar formulario',
    agregarFormulario: 'Agregar formulario',
    pideTitulo: 'Escribe el título',
    pideSubtitulo: 'Escribe el subtítulo',
    archivoSubido: '{archivo}: archivo subido.',
    archivoFallo: '{archivo}: no se pudo subir.',
  },

  formPublico: {
    dejanosTusDatos: 'Déjanos tus datos',
    enviar: 'Enviar',
    enviando: 'Enviando…',
    completaTodo: 'Completa todos los campos.',
    gracias: '¡Gracias! Te contactaremos pronto.',
    errorEnviar: 'No se pudo enviar. Revisa los datos e intenta de nuevo.',
  },

  menu: {
    aplicaciones: 'APLICACIONES',
    administracion: 'Administración',
    panel: 'Panel',
    roles: 'Roles',
    usuarios: 'Usuarios',
    paquetes: 'Paquetes',
    contactos: 'Contactos',
    oportunidades: 'Oportunidades',
    notas: 'Notas',
    formularios: 'Formularios',
    tickets: 'Tickets',
    campanas: 'Campañas',
    conversaciones: 'Conversaciones',
    clientesYCanales: 'Clientes y canales',
  },

  bandeja: {
    titulo: 'Conversaciones',
    elegirConversacion: 'Selecciona una conversación para ver los mensajes.',
    equipo: 'Equipo',
    mias: 'Mías',
    sinAsignar: 'Sin asignar',
    abiertas: 'Abiertas',
    resueltas: 'Resueltas',
    todosLosCanales: 'Todos los canales',
    escribeRespuesta: 'Escribe una respuesta…',
    nombreDelContacto: 'Nombre del contacto',
    alEmbudo: 'Agregarlo al embudo de Oportunidades',
    agregadoAlEmbudo: 'Agregado al embudo',
    atiende: 'Atiende',
    tomarla: 'Tomarla',
    canalCaidoTitulo: '{canal} está desconectado',
    canalCaidoDetalle: 'No están entrando mensajes nuevos por ahí. Contacta a tu administrador para volver a conectarlo.',
    canalesCaidosTitulo: '{n} canales están desconectados',
    canalesCaidosDetalle: 'No están entrando mensajes nuevos por {canales}. Contacta a tu administrador para volver a conectarlos.',
    canalEmail: 'Correo',
    canalOtro: 'Otro',
    vacioTodas: 'No hay conversaciones todavía.',
    vacioMias: 'No tienes conversaciones asignadas.',
    vacioSinAsignar: 'No hay conversaciones sin asignar.',
    errorLista: 'No se pudieron cargar las conversaciones.',
    errorMensajes: 'No se pudieron cargar los mensajes.',
    errorEnviar: 'No se pudo enviar el mensaje.',
    errorAsignar: 'No se pudo asignar.',
    errorNombre: 'No se pudo guardar el nombre.',
    errorEmbudo: 'No se pudo agregar al embudo.',
    escribeNombre: 'Escribe un nombre.',
    avisosSinSoporte: 'Este navegador no permite avisos de escritorio.',
    avisosBloqueados: 'Los avisos quedaron bloqueados en el navegador.',
    activarAvisos: 'Activar avisos',
    editar: 'Editar',
    ponerNombre: 'Poner nombre',
    creando: 'Creando…',
    enviando: 'Enviando…',
    botonEmbudo: '+ Al embudo',
    sinNombre: 'Sin nombre',
    nadie: 'nadie',
    yo: 'yo',
    avisosListos: 'Listo: te avisaremos aunque estés en otra pestaña.',
    nombreGuardado: 'Nombre guardado.',
    noEstaEnLaLista: 'Esa conversación no está en la lista actual. Prueba cambiando el filtro a «Todas».',
    teAsignaron: 'Te asignaron un chat',
    contactoGenerico: 'Contacto',
    elContacto: 'El contacto',
    agregadoAlEmbudoDetalle: '{nombre} ya aparece en Oportunidades, en la primera etapa.',
    chatNuevo: 'Chat nuevo',
  },

  equipo: {
    tituloModal: 'Equipo de WhatsApp',
    ayuda: 'Las personas que agregues aquí entran a este mismo CRM con su correo y su clave, ven esta bandeja y responden con su propio nombre.',
    cupo: 'Tu plan incluye {personas} contándote a ti.',
    nPersonas: '{n} personas',
    puedesAgregar: 'Puedes agregar {n} más.',
    yaLasUsaste: 'Ya las usaste todas.',
    colPersona: 'Persona',
    colAcceso: 'Acceso',
    yaEntro: 'Ya entró',
    sinEntrar: 'Sin entrar aún',
    quitar: 'Quitar',
    siNadieContesta: 'Si nadie contesta',
    ayudaEscalado: 'Pasa el chat al siguiente de la lista cuando lleve minutos sin respuesta. Al terminar la vuelta lo deja en {sinAsignar} para que lo vea todo el equipo.',
    minutosSinRespuesta: 'Minutos sin respuesta (vacío = apagado)',
    zonaHoraria: 'Zona horaria',
    diasDeAtencion: 'Días de atención',
    desde: 'Desde',
    hasta: 'Hasta',
    lun: 'Lun',
    mar: 'Mar',
    mie: 'Mié',
    jue: 'Jue',
    vie: 'Vie',
    sab: 'Sáb',
    dom: 'Dom',
    notaClave: 'Tú pones la clave inicial, así que la conoces. Pídele a cada persona que la cambie en {perfil} la primera vez que entre.',
    perfilCambiarClave: 'Perfil → cambiar contraseña',
    agregarPersona: '+ Agregar persona',
    notaCupoLleno: 'Para sumar a alguien más, escríbele a tu administrador: son $15 al mes por persona.',
    correoConEntra: 'Correo (con el que va a entrar)',
    claveMinimo8: 'Clave (mínimo 8 caracteres)',
    agregando: 'Agregando…',
    escaladoListo: 'Listo: si nadie contesta en {n} min, el chat pasa al siguiente.',
    escaladoApagado: 'Escalado apagado.',
    errorGuardar: 'No se pudo guardar.',
    errorCargarEquipo: 'No se pudo cargar el equipo.',
    personaAgregada: 'Persona agregada',
    personaAgregadaDetalle: 'Ya puede entrar a app.crmproyectx.com con {correo} y la clave que acabas de poner. Pídele que la cambie en Perfil una vez adentro.',
    errorAgregar: 'No se pudo agregar.',
    quitarDelEquipo: 'Quitar del equipo',
    quitarDetalle: '{nombre} dejará de entrar al CRM y de ver esta bandeja. Los mensajes que ya envió se conservan con su nombre.',
    personaQuitada: 'Persona quitada del equipo.',
    errorQuitar: 'No se pudo quitar.',
  },

  canal: {
    tituloSinCanales: 'Canales',
    sinCanales: 'Todavía no tienes ningún canal conectado',
    conectaFacebook: 'Conecta tu página de Facebook y responde sus mensajes desde aquí, junto con los demás canales.',
    avisoSinActivar: 'Para activar la bandeja de WhatsApp de tu cuenta, contacta al administrador. El equipo de soporte configura tu número y aquí aparecerán tus conversaciones.',
    conectadoAl: 'Conectado al número {numero}',
    conectaTuNumero: 'Conecta tu número de WhatsApp para recibir y responder mensajes',
    numeroDeWhatsapp: 'Número de WhatsApp',
    pideAccountSid: 'Ingresa el Account SID',
    pideAuthToken: 'Ingresa el Auth Token',
    pideNumero: 'Ingresa el número',
    seGuardaCifrado: 'Se guarda cifrado; no se vuelve a mostrar',
    actualizarConexion: 'Actualizar conexión',
    conectarWhatsapp: 'Conectar WhatsApp',
    desconectar: 'Desconectar',
    conectado: 'WhatsApp conectado correctamente.',
    desconectado: 'WhatsApp desconectado.',
    errorGuardar: 'No se pudo guardar. Revisa los datos.',
    errorDesconectar: 'No se pudo desconectar.',
  },

  clientes: {
    titulo: 'WhatsApp de los clientes',
    contador: 'clientes',
    buscarCliente: 'Buscar cliente ...',
    ayuda: 'Cada cliente tiene su propia cuenta de WhatsApp, aislada de la de los demás. Primero se le crea la cuenta, después se conecta su número.',
    colCliente: 'Cliente',
    colCuenta: 'Cuenta de WhatsApp',
    colNumero: 'Número',
    sinNombre: '(sin nombre)',
    cuentaCreada: 'Cuenta creada (#{n})',
    sinCuenta: 'Sin cuenta',
    enlazado: 'Enlazado',
    faltaEnlazar: 'Falta enlazar la bandeja',
    sinNumero: 'Sin número',
    crearCuenta: 'Crear cuenta',
    cambiarNumero: 'Cambiar número',
    conectarNumero: 'Conectar número',
    marca: 'Marca',
    marcaDe: 'Marca de {nombre}',
    ayudaMarca: 'El cliente y su equipo verán este logo y este nombre dentro del CRM, en lugar de los nuestros. La pantalla de inicio de sesión no cambia.',
    phNegocio: 'Clínica Ejemplo',
    campoLogo: 'Logo (PNG o JPG, máximo 1 MB)',
    logoActual: 'Logo actual:',
    guardarMarca: 'Guardar marca',
    volverMarcaCrm: 'Volver a la marca del CRM',
    volverMarcaCrmDetalle: '{nombre} verá de nuevo el logo y el nombre de CRM ProyectX.',
    quitarMarca: 'Quitar marca',
    marcaGuardada: 'Marca guardada. El cliente la verá al recargar.',
    marcaQuitada: 'Marca quitada.',
    conectarWhatsappDe: 'Conectar WhatsApp de {nombre}',
    ayudaEnlace: 'La bandeja se enlaza sola si ya existe con este mismo número.',
    guardarConexion: 'Guardar conexión',
    numeroConectado: 'Número conectado.',
    cuentaCreadaAviso: 'Cuenta creada.',
    reenlazarTitulo: 'Hay que volver a enlazar el número',
    reenlazarDetalle: 'Este cliente estaba en la cuenta compartida. Crea su bandeja en su cuenta nueva y vuelve a guardar el número aquí.',
    desconectarTitulo: 'Desconectar WhatsApp',
    desconectarDetalle: 'El cliente {nombre} dejará de ver su bandeja. Se puede volver a conectar después.',
    errorCargar: 'No se pudo cargar la lista de clientes.',
    errorCrearCuenta: 'No se pudo crear la cuenta.',
    errorGuardarMarca: 'No se pudo guardar la marca.',
    errorQuitarMarca: 'No se pudo quitar la marca.',
  },

  embudo: {
    titulo: 'Oportunidades',
    configurarEtapas: 'Configurar etapas',
    etiquetas: 'Etiquetas',
    conTodasLasEtiquetas: 'mostrando quienes tienen todas las seleccionadas',
  },

  etapas: {
    titulo: 'Etapas del embudo',
    ayuda: 'Estas son las columnas de tu tablero. Puedes renombrarlas, cambiarles el color y ordenarlas como trabajes tú.',
    nombreNueva: 'Nombre de la etapa nueva',
    entrada: 'entrada',
    nombreEntrada: 'Hot Leads',
    ayudaEntrada: 'Aquí caen los leads nuevos. No se puede renombrar ni borrar.',
    subir: 'Subir',
    bajar: 'Bajar',
    color: 'Color',
    borrarTitulo: 'Borrar «{nombre}»',
    tieneContactos: 'Esta etapa tiene {n} contacto(s). ¿A qué etapa los movemos?',
    eligeEtapa: 'Elige una etapa',
    estaVacia: 'La etapa está vacía. Se borrará sin mover nada.',
    errorCargar: 'No se pudieron cargar las etapas.',
    errorCrear: 'No se pudo crear la etapa.',
    errorRenombrar: 'No se pudo renombrar la etapa.',
    errorColor: 'No se pudo cambiar el color.',
    errorOrden: 'No se pudo reordenar.',
    errorBorrar: 'No se pudo borrar la etapa.',
  },

  notas: {
    titulo: 'Notas',
    lista: 'Lista de notas',
    agregar: 'Agregar nota',
    actualizar: 'Actualizar nota',
    favoritas: 'Favoritas',
    etiquetas: 'Etiquetas',
    personal: 'Personal',
    trabajo: 'Trabajo',
    social: 'Social',
    importante: 'Importante',
    campoTitulo: 'Título',
    campoDescripcion: 'Descripción',
    campoEtiqueta: 'Etiqueta de la nota',
    phTitulo: 'Título de la nota',
    phDescripcion: 'Descripción de la nota',
    pideTitulo: 'Escribe el título',
    pideDescripcion: 'Escribe la descripción',
    confirmarBorrado: '¿Seguro que quieres borrar esta nota?',
  },

  tickets: {
    titulo: 'Tickets',
    tituloModal: 'Ticket',
    detalle: 'Detalle del ticket',
    conversacion: 'Conversación',
    phMensaje: 'Escribe tu mensaje…',
    estado: 'Estado',
    abierto: 'Abierto',
    pendiente: 'Pendiente',
    cerrado: 'Cerrado',
    colUsuario: 'Usuario',
    colDescripcion: 'Descripción',
    colTipo: 'Tipo',
    colPrioridad: 'Prioridad',
    colEstado: 'Estado',
    colCreado: 'Fecha de creación',
    colActualizado: 'Última actualización',
    tipo_support: 'Soporte',
    tipo_payment: 'Pago',
    prioridad_high: 'Alta',
    prioridad_medium: 'Media',
    prioridad_low: 'Baja',
    estado_open: 'Abierto',
    estado_pending: 'Pendiente',
    estado_close: 'Cerrado',
    pideDescripcion: 'Escribe la descripción',
    actualizar: 'Actualizar ticket',
    agregar: 'Crear ticket',
  },

  panel: {
    titulo: 'Panel',
    resumenEmbudo: 'Resumen del embudo',
    resumenTickets: 'Resumen de tickets',
    tarjetaContactos: 'Contactos',
    tarjetaSms: 'SMS',
    tarjetaCorreo: 'Correos',
    tarjetaTicketsAbiertos: 'Tickets abiertos',
  },

  sesion: {
    salir: 'Cerrar sesión',
  },

  perfil: {
    miCuenta: 'Mi cuenta',
    miPerfil: 'Mi perfil',
    cambiarContrasena: 'Cambiar contraseña',
    miMarca: 'Mi marca',
    configuracion: 'Configuración del negocio',
    leadsFacebook: 'Leads de Facebook',
    camposPropios: 'Campos del contacto',
    misDatos: 'Mis datos',
    tuInformacion: 'Tu información personal',
    identificacion: 'Identificación',
    direccion: 'Dirección',
    rol: 'Rol',
    contrasena: 'Contraseña',
    cambiaLaContrasena: 'Cambia la contraseña de tu cuenta',
    contrasenaActual: 'Contraseña actual',
    contrasenaNueva: 'Contraseña nueva',
    repiteLaNueva: 'Repite la nueva',
    minimo8: 'Mínimo 8 caracteres',
    tuMarca: 'Tu marca',
    ayudaMarca: 'Pon el nombre y el logo de tu negocio. Aparecerán en el menú, en el pie de página y en el título de la pestaña del navegador, para ti y para todo tu equipo.',
    nombreDelNegocio: 'Nombre del negocio',
    ejemploNegocio: 'Ej.: Associates Rehab',
    logo: 'Logo',
    elegirImagen: 'Elegir imagen',
    formatoLogo: 'PNG, JPG o WEBP. Máximo 1 MB.',
    quitarMiMarca: 'Quitar mi marca',
    redes: 'Redes sociales',
    ayudaRedes: 'Agrega los enlaces de tu perfil',
  },

  // Conectar Facebook para recibir LEADS. Va aparte de `facebook`, que es la
  // conexion de Messenger: son dos apps de Meta distintas y dos flujos
  // distintos, y mezclar los textos haria que un cambio en uno tocara el otro.
  // Los campos a medida de la ficha del contacto. Nacen con los leads de
  // Facebook (un formulario puede preguntar «¿cuando se muda?»), pero sirven
  // para todo el CRM.
  camposPropios: {
    titulo: 'Campos del contacto',
    intro: 'Agrega los datos que tu negocio necesita guardar de cada contacto, además de los que ya vienen. Después podrás llenarlos a mano o traerlos desde tus formularios de Facebook.',
    nuevo: 'Nuevo campo',
    nuevoCampo: 'Nuevo campo',
    editarCampo: 'Editar campo',
    editar: 'Editar',
    etiqueta: 'Nombre del campo',
    ejemploEtiqueta: 'Por ejemplo: Presupuesto',
    llave: 'Clave',
    tipo: 'Tipo',
    opciones: 'Opciones',
    ejemploOpciones: 'Una opción por línea',
    nadaAun: 'Todavía no has creado ningún campo.',
    guardado: 'Campo guardado.',
    borrado: 'Campo borrado.',
    confirmarBorrar: 'Se borrará el campo y lo que hayan contestado tus contactos. ¿Continuar?',
    faltaEtiqueta: 'Ponle un nombre al campo.',
    faltanOpciones: 'Una lista necesita al menos una opción.',
    avisoLlave: 'Puedes cambiar el nombre cuando quieras: la clave «{llave}» no cambia, y es la que mantiene vivo el enlace con tus formularios de Facebook.',
    errorCargar: 'No se pudieron cargar tus campos.',
    errorGuardar: 'No se pudo guardar el campo.',
    errorBorrar: 'No se pudo borrar el campo.',
    tipos: {
      text: 'Texto',
      textarea: 'Texto largo',
      number: 'Número',
      date: 'Fecha',
      select: 'Lista',
      boolean: 'Sí / No',
    },
  },

  leadsFacebook: {
    titulo: 'Leads de Facebook',
    intro: 'Conecta tu página de Facebook y los leads de tus formularios entrarán solos en tu embudo, sin que tengas que descargar nada.',
    conectar: 'Conectar Facebook',
    conectada: 'Página conectada',
    desconectar: 'Desconectar',
    desconectada: 'Página desconectada.',
    confirmarDesconectar: '¿Dejar de recibir los leads de esta página?',
    nadaConectado: 'Todavía no has conectado ninguna página.',
    elegirPagina: 'Elige tu página',
    ayudaElegirPagina: 'Estas son las páginas que administras. Elige de cuál quieres recibir los leads.',
    elegirFormulario: '¿Qué formulario?',
    ayudaElegirFormulario: 'Si no eliges ninguno, recibirás los leads de todos los formularios de esa página. Es lo más habitual.',
    todosLosFormularios: 'Todos los formularios',
    ultimoLead: 'Último lead',
    sinLeadsAun: 'Conectada. Esperando el primer lead.',
    sinSuscribir: 'Sin suscribir',
    mapeo: 'A dónde va cada respuesta',
    ayudaMapeo: 'Elige en qué parte de la ficha del contacto quieres guardar cada respuesta del formulario. Lo que no elijas igual queda guardado en el detalle del lead.',
    editarMapeo: 'Campos',
    paraCambiar: 'Para conectar otra página, desconecta primero la actual.',
    enviarPrueba: 'Probar',
    pruebaEnviada: 'Lead de prueba enviado',
    errorPrueba: 'No se pudo enviar el lead de prueba.',
    mapeoGuardado: 'Guardado. Los próximos leads llenarán estos campos.',
    noGuardar: 'No guardarlo en ningún campo',
    sinPreguntas: 'No pudimos leer las preguntas de este formulario.',
    crearCampos: '¿Te falta un campo? Créalo en Campos del contacto',
    avisoSinMapeo: 'Con todos los formularios no se puede elegir a dónde va cada respuesta, porque cada formulario pregunta cosas distintas. Los datos de contacto se reconocen solos.',
    errorMapeo: 'No se pudo guardar la configuración.',
    errorPreguntas: 'No se pudieron leer las preguntas del formulario.',
    destinos: {
      first_name: 'Nombre',
      last_name: 'Apellido',
      full_name: 'Nombre completo',
      email: 'Correo',
      phone: 'Teléfono',
      address: 'Dirección',
      note: 'Nota del contacto',
    },
    errorCargar: 'No se pudieron cargar tus páginas conectadas.',
    errorFormularios: 'No se pudieron leer los formularios de esa página. Puedes conectarla igual y recibirás los de todos.',
    errorDesconectar: 'No se pudo desconectar la página.',
  },

  facebook: {
    conectar: 'Conectar Facebook',
    canales: 'Channels',
    tusCanales: 'Tus canales conectados',
    sinCanalesConectados: 'Todavía no tienes ninguna página conectada.',
    desconectar: 'Desconectar',
    desconectada: 'Página desconectada.',
    confirmarDesconexion: 'Desconectar «{nombre}»',
    avisoDesconexion: 'Dejarás de recibir los mensajes de esa página. Puedes volver a conectarla cuando quieras.',
    errorDesconectar: 'No se pudo desconectar la página.',
    conectando: 'Conectando…',
    conectada: 'Página conectada',
    elegirPagina: 'Elige tu página',
    ayudaElegir: 'Administras varias páginas. Elige la que quieres atender desde aquí.',
    usarEsta: 'Usar esta',
    yaConectada: 'Ya conectada',
    errorEntrar: 'No se pudo entrar con Facebook. Intenta de nuevo.',
    errorConectar: 'No se pudo conectar la página.',
  },

  ficha: {
    verDetalle: 'Ver detalle técnico',
    ocultarDetalle: 'Ocultar detalle técnico',
    idCampana: 'ID campaña',
    idConjunto: 'ID conjunto',
    idAnuncio: 'ID anuncio',
    idFormulario: 'ID formulario',
    paginaEntrada: 'Página de entrada',
    referente: 'Referente',
    guardarNota: 'Guardar nota',
    camposPropios: 'Campos del contacto',
    no: 'No',
    etiquetas: 'ETIQUETAS',
    nuevaEtiqueta: '+ Etiqueta',
    escribeEtiqueta: 'nombre y Enter',
    quitar: 'Quitar',
    buscando: 'Buscando…',
    nota: 'NOTA',
    ejemploNota: 'Ej.: llamar en 8 días · está muy interesado, es urgente · no contesta por la mañana',
    datos: 'DATOS',
    editar: 'Editar',
    copiar: 'Copiar',
    copiado: '¡Copiado!',
    registrado: 'Registrado',
    etapa: 'ETAPA',
    sinEtapa: 'Sin etapa',
    llamar: 'Llamar',
    procedencia: 'Procedencia',
    origen: 'Origen',
    campana: 'Campaña',
    conjunto: 'Conjunto',
    anuncio: 'Anuncio',
    formulario: 'Formulario',
    utmCampana: 'UTM campaña',
    comentario: 'Comentario',
    direccion: 'Dirección',
    guardando: 'guardando…',
    guardada: 'guardada ✓',
    guardado: 'guardado ✓',
    descartar: 'Descartar',
    cerrar: 'Cerrar',
  },

  tabla: {
    contactos: 'contactos',
    importar: 'Importar',
    nuevoContacto: '+ Nuevo contacto',
    nota: 'Nota',
    confirmarBorrado: '¿Seguro que quieres eliminar este contacto?',
  },

  contacto: {
    nuevo: 'Nuevo contacto',
    editar: 'Editar contacto',
    cliente: 'Cliente',
    eligeCliente: 'Elige el cliente',
    nota: 'Nota',
    phNota: 'Ej.: llamar en 8 días · muy interesado, es urgente',
    telefonoConPrefijo: 'Teléfono (con +1)',
    guardarCambios: 'Guardar cambios',
    crear: 'Crear contacto',
    pideNombre: 'Escribe el nombre',
    pideApellido: 'Escribe el apellido',
    pideCorreo: 'Escribe el correo',
    pideDireccion: 'Escribe la dirección',
    pideTelefono: 'Escribe el teléfono',
  },

  contactos: {
    titulo: 'Contactos',
  },
};
